import React from 'react';
import { Alert, Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';

const formatCurrency = (value) => new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
}).format(value);

const pickupLabel = (quote, merchantId, merchantOptions) => {
  const provided = quote.pickupOrigin;
  const explicit = typeof provided === 'string'
    ? provided.trim()
    : String(provided?.label || provided?.address || '').trim();
  if (explicit) return explicit;
  if (quote.provider === 'ifood') {
    const merchant = merchantOptions.find((item) => item.id === merchantId);
    const name = String(merchant?.name || '').trim();
    return name && name !== merchantId
      ? `Loja iFood ${name} (${merchantId})`
      : `Loja iFood ${merchantId || 'não identificada'}`;
  }
  if (quote.provider === 'bee') {
    return 'Loja vinculada no Brutos Entregas; endereço não informado';
  }
  return 'Ponto de coleta não informado';
};

const CourierQuoteOptions = ({ quotes = [], merchantId = '', merchantOptions = [], selectedQuoteId = '', onSelect, canHireBeeSandbox = false, canHireBee = false, canHireIfood = true }) => (
  <Stack spacing={1.5}>
    {quotes.some((quote) => quote.provider === 'ifood' && quote.available !== false)
      && quotes.some((quote) => quote.provider === 'bee' && quote.available !== false) && (
      <Alert severity="warning">
        As origens de coleta não foram verificadas como equivalentes. Os preços podem considerar lojas diferentes; confirme o ponto de coleta fora desta comparação antes de contratar.
      </Alert>
    )}
    {quotes.map((quote) => {
      const amount = Number.isSafeInteger(quote.feeCents) && quote.feeCents >= 0
        ? quote.feeCents / 100
        : quote.fee === null || quote.fee === undefined ? null : Number(quote.fee);
      const canSelect = quote.available !== false && (
        (quote.provider === 'ifood' && canHireIfood)
        || (quote.provider === 'bee' && (canHireBee || canHireBeeSandbox) && Number.isSafeInteger(quote.feeCents) && quote.feeCents >= 0)
      );
      const selected = canSelect && quote.id === selectedQuoteId;
      const content = (
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2} sx={{ width: '100%' }}>
          <Box>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography fontWeight={700}>{quote.providerLabel || quote.provider}</Typography>
              {quote.provider === 'bee' && canSelect && canHireBeeSandbox && <Chip label="Sandbox" size="small" color="warning" />}
              {!canSelect && quote.available !== false && <Chip label="Somente cotação" size="small" />}
            </Stack>
            <Typography variant="body2">
              Origem da coleta: {pickupLabel(quote, merchantId, merchantOptions)}
            </Typography>
            <Typography variant="body2">
              {quote.available === false
                ? quote.reason || 'Indisponível para este pedido'
                : quote.etaMinutes ? `Previsão: ${quote.etaMinutes} min` : 'Previsão não informada'}
            </Typography>
          </Box>
          <Typography fontWeight={700} sx={{ whiteSpace: 'nowrap' }}>
            {Number.isFinite(amount) ? formatCurrency(amount) : 'Sem preço'}
          </Typography>
        </Stack>
      );
      return canSelect ? (
        <Button
          key={`${quote.provider}:${quote.id}`}
          variant={selected ? 'contained' : 'outlined'}
          onClick={() => onSelect(quote.id)}
          aria-pressed={selected}
          sx={{ textAlign: 'left', py: 1.5 }}
        >
          {content}
        </Button>
      ) : (
        <Paper key={`${quote.provider}:${quote.id}`} variant="outlined" sx={{ p: 1.5 }}>
          {content}
        </Paper>
      );
    })}
  </Stack>
);

export default CourierQuoteOptions;
